const googleMapInit = (options, selector, infoDialog = false) => {
    const loc = options.loc, parent = $(selector).parent();

    const mapStyles = [
        {
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#bdbdbd"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dadada"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#c9c9c9"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        }
    ];

    const iconBlue = ajax_url['themeUrl'] + '/assets/images/map/location.png',
        iconGray = ajax_url['themeUrl'] + '/assets/images/map/location-gray.png';

    const mapOptions = {
        zoom: options.zoom,
        center: {lat: parseFloat(loc[0].lat), lng: parseFloat(loc[0].lng)},
        styles: mapStyles,
        gestureHandling: 'cooperative',
    };

    if (typeof google !== typeof undefined) {
        const mapElement = document.querySelector(selector);
        const bounds = new google.maps.LatLngBounds();
        const map = new google.maps.Map(mapElement, mapOptions);
        let markers = [];

        loc.forEach((location, key) => {
            markers[key] = new google.maps.Marker({
                position: {lat: parseFloat(location.lat), lng: parseFloat(location.lng)},
                map: map,
                icon: {
                    url: iconBlue,
                    size: new google.maps.Size(28, 28),
                },
            });

            bounds.extend(markers[key].position);
        })


        if (infoDialog) {
            markers.forEach((marker, key) => {
                renderDialog(loc[key], key);

                if(key === 0){
                    showDialog (key);
                    marker.setIcon(iconGray);
                }

                marker.addListener("click", () => {
                    markers.forEach((item, i) => {
                        if (key === i) {
                            showDialog (key);
                            item.setIcon(iconGray);
                        } else {
                            item.setIcon(iconBlue);
                        }
                    })
                });
            })
        }

        if (loc.length > 1) {
            if ($(window).width() > 768) {
                map.fitBounds(bounds, {right: 370});
            }else{
                map.fitBounds(bounds, {right: 0});
            }
        }

        parent.addClass('loaded');
    }

    function renderDialog(item, index) {

        let markup = `
           <div class="map-info" id="map-info-${index}" style="display: none;">
              <p class="map-info__title black h5 text-uppercase">${item.title}</p>`

        if (item.address !== '') {
            markup += `<p class="map-info__item map-info__item--address">${item.address}</p>`;
        }

        if (item.phone !== '') {
            markup += `<div class="map-info__item map-info__item--phone"><a href="${item.phone_link}"></a>${item.phone}</div>`;
        }

        if (item.link !== '') {
            markup += `<div class="map-info__item map-info__item--link"><a href="${item.link}"></a>${item.link_text}</div>`;
        }

        markup += '</div>';

        parent.append(markup);
    }

    function showDialog (index) {
        const dialogs = parent.find('.map-info');
        dialogs.each((i, el) => {
            index === i? $(el).fadeIn(): $(el).fadeOut()
        })
    }

};

export default googleMapInit;